module.exports = __webpack_public_path__ + "495fab6efb27c0ac8f0b6ae1a122f146.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-8.svg
// module id = 598
// module chunks = 0